<template>
  <a-form-item :label="data.fieldname">
    <div
      v-decorator="[`${data.fieldkey}`, {
        validateTrigger: ['change', 'blur'],
        rules: [{
          required: data.isneeded === 1 ? true : false,
          message: placeholder
        }],
        initialValue: tags
      }]"
      class="wrap"
    >
      <template v-for="(tag) in tags">
        <a-tooltip
          v-if="tag.length > 20"
          :key="tag"
          :title="tag"
        >
          <a-tag
            :key="tag"
            closable
            :after-close="() => handleClose(tag)"
          >
            {{ `${tag.slice(0, 20)}...` }}
          </a-tag>
        </a-tooltip>
        <a-tag
          v-else
          :key="tag"
          closable
          :after-close="() => handleClose(tag)"
        >
          {{ tag }}
        </a-tag>
      </template>
      <a-input
        v-if="inputVisible"
        ref="input"
        type="text"
        size="small"
        :style="{ width: '78px' }"
        @change="handleInputChange"
        @blur="handleInputConfirm"
        @keyup.enter="handleInputConfirm"
      />
      <a-tag
        v-else
        style="background: #fff; borderStyle: dashed;"
        @click="showInput"
      >
        <a-icon type="plus" /> {{ $t('message["1190"]') }}
      </a-tag>
    </div>
  </a-form-item>
</template>

<script>

export default {
  inject: {
    myForm: {
      type: Object,
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tags: this.data.fieldvalue || [],
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    handleClose (removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag)
      this.tags = tags

      if (this.data.isneeded) {
        this.myForm && this.myForm.setFieldsValue({
          [this.data.fieldkey]: this.tags
        })
        this.myForm && this.myForm.validateFields([this.data.fieldkey], this.validatedCallback)
      } else {
        this.$emit('change', this.tags)
      }
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },

    handleInputChange (e) {
      this.inputValue = e.target.value
    },

    handleInputConfirm () {
      let { tags, inputValue } = this
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }

      this.tags = tags
      Object.assign(this, {
        inputVisible: false,
        inputValue: ''
      })

      if (this.data.isneeded) {
        this.myForm && this.myForm.setFieldsValue({
          [this.data.fieldkey]: this.tags
        })
        this.myForm && this.myForm.validateFields([this.data.fieldkey], this.validatedCallback)
      } else {
        this.$emit('change', this.tags)
      }
    },
    validatedCallback (err, values) {
      if (!err) {
        this.$emit('change', this.tags)
      }
    },
    checkValue (rule, value = [], callback) {
      // console.log('arg: ', arguments)
      const { isneeded } = this.data
      if (!isneeded) {
        callback()
      } else {
        console.log('value: ', value)
        if (value.length) {
          callback()
        } else {
          callback(new Error(this.placeholder))
        }
      }
    }
  }
}
</script>
